import React from 'react';
import { Plus } from 'lucide-react';
import { motion } from 'framer-motion';
import { Product } from '../../data/mockProducts';
import { useCart } from '../../hooks/useCart';
import { TrustBadge } from '../ui/TrustBadge';
interface ProductCardProps {
  product: Product;
}
export function ProductCard({
  product
}: ProductCardProps) {
  const {
    addToCart
  } = useCart();
  return <motion.div className="group bg-white rounded-2xl border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 flex flex-col h-full" whileHover={{
    y: -4
  }} initial={{
    opacity: 0,
    scale: 0.95
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true
  }} data-id="element-132">
      <div className="relative aspect-square overflow-hidden bg-gray-50" data-id="element-133">
        <img src={product.image} alt={product.altText} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-134" />
        <div className="absolute top-3 left-3 flex flex-col gap-2" data-id="element-135">
          {product.isWIC && <TrustBadge type="WIC" size="sm" data-id="element-136" />}
          {product.isEBT && <TrustBadge type="EBT" size="sm" data-id="element-137" />}
        </div>
      </div>

      <div className="p-5 flex flex-col flex-grow" data-id="element-138">
        <div className="mb-1" data-id="element-139">
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-140">
            {product.category}
          </span>
        </div>
        <h3 className="font-bold text-gray-900 text-lg mb-2 line-clamp-2" data-id="element-141">
          {product.name}
        </h3>
        {product.description && <p className="text-sm text-gray-600 mb-4 line-clamp-2 flex-grow" data-id="element-142">
            {product.description}
          </p>}

        <div className="mt-auto flex items-center justify-between pt-4 border-t border-gray-50" data-id="element-143">
          <span className="text-xl font-bold text-blue-600" data-id="element-144">
            ${product.price.toFixed(2)}
          </span>

          <button onClick={() => addToCart(product)} className="flex items-center gap-2 bg-purple-500 text-white px-4 py-2 rounded-lg font-semibold text-sm hover:bg-purple-600 transition-colors active:scale-95" aria-label={`Add ${product.name} to cart`} data-id="element-145">
            <Plus className="w-4 h-4" data-id="element-146" />
            Add
          </button>
        </div>
      </div>
    </motion.div>;
}